import React, { useEffect } from 'react';
import ReactDoM from 'react-dom';
import { connect } from 'react-redux';
import * as constants from 'constants/App';
import { Map } from 'immutable';
import { defineMessages } from 'react-intl';
import { emptyMapIfUndefined, falseIfUndefined, emptyStringIfUndefined, validateEmail, renderError, validatePasswordPolicy } from 'utils/HelperFunctions';
import AccountInfo from '../components/AccountInfo';
import BankingInfo from '../components/BankingInfo';
import ServiceProfile from '../components/ServiceProfile';
import AuthEmailNotification from '../components/AuthEmailNotification';
import RegistrationViewSelector from '../selectors/RegistrationView';
import './RegistrationView.css';
import TermsAndConditions from '../components/VendorTermsAndConditionsRegister';
import * as sharedActions from 'shared/actions/App';
import * as CookieHelper from 'utils/CookieHelper';
import * as appActions from '../../../../actions/App';
import ServiceContact from '../components/ServiceContact.tsx';
import { useParams } from 'react-router-dom';
const RegistrationView = (props) => {
    const params = useParams();
    const step = params.step;

    useEffect(() => {
        props.dispatch({ type: constants.RESET_REGISTRATION });
        props.dispatch({ type: constants.CLEAR_ERROR_MESSAGE });
    }, [props.dispatch]);

    const isFieldEmpty = (value) => {
        return (emptyStringIfUndefined(value) == '' || value.length == undefined || value.length == 0);
    }

    const validateFormForAccountInfo = () => {
        const errorMessages = defineMessages({
            ari_required: {
                id: 'ari_required',
                description: 'Please enter the correct ID supplied by Holman',
                defaultMessage: 'Please enter the correct ID supplied by Holman'
            },
            tax_id_required: {
                id: 'tax_id_required',
                description: 'Please enter either SSN or Employer Id',
                defaultMessage: 'Please enter either SSN or Employer Id'
            },
            password_required: {
                id: 'password_required',
                description: 'Please enter Password',
                defaultMessage: 'Please enter Password'
            },
            confirm_password_required: {
                id: 'confirm_password_required',
                description: 'Please confirm password',
                defaultMessage: 'Please confirm password'
            },
            password_should_match: {
                id: 'password_should_match',
                description: 'Password does not match',
                defaultMessage: 'Password does not match'
            },
            business_number_required:{
                id:'business_number_required',
                description:'Please enter Business Number',
                defaultMessage:'Please enter Business Number'
            },
            federal_tax_id_required:{
                id:'federal_tax_id_required',
                description:'Pleae enter Federal Tax Id',
                defaultMessage:'Pleae enter Federal Tax Id'
            },
            password_field_required: {
                id: 'password_field_required',
                description: 'Please enter valid password',
                defaultMessage: 'Password must meet complexity criteria below'
            }
        })

        let isFormValid = true;
        const country=props.formData.get(constants.FORM_DATA.COUNTRY);

        //check ari id field
        //  required 
        const ariId = props.formData.get(constants.FORM_DATA.ARI_ID);
        let validationErrs;
        if (isFieldEmpty(ariId)) {
            isFormValid = false;
            validationErrs = {
                name: constants.FORM_DATA.ARI_ID,
                value: errorMessages.ari_required
            }
            props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
        }
        //check tax id field
        if(country=='CAN'){            
            //business_number_required
            const businessNumber=props.formData.get(constants.FORM_DATA.BUSINESS_NUMBER);
            var bnTestExpression = /^\d{9}$/;
            if(isFieldEmpty(businessNumber)||!bnTestExpression.test(businessNumber)){
                isFormValid=false;
                validationErrs={
                    name:constants.FORM_DATA.BUSINESS_NUMBER,
                    value:errorMessages.business_number_required                }

                props.dispatch({type:constants.UPDATE_FORM_DATA_VALIDATION_ERRS,validationErrs});
            }
            
        }
        else if (country=='MEX'){
            //Federal Tax Id required
            const federalTaxId=props.formData.get(constants.FORM_DATA.FEDERAL_TAX_ID);
            var taxTestExpression = /^[a-zA-Z0-9_]*$/;
            if(isFieldEmpty(federalTaxId)||!taxTestExpression.test(federalTaxId)){
                isFormValid=false;
                validationErrs={
                    name:constants.FORM_DATA.FEDERAL_TAX_ID,
                    value:errorMessages.federal_tax_id_required                }

                props.dispatch({type:constants.UPDATE_FORM_DATA_VALIDATION_ERRS,validationErrs});
            }
        }
        else{
            //  only one required 
            //  both cannot be filled 
            let ssn = props.formData.get(constants.FORM_DATA.SSN);
            let employerId = props.formData.get(constants.FORM_DATA.EMPLOYER_ID);
            let fieldsEmpty = isFieldEmpty(ssn) && isFieldEmpty(employerId);
            if ((isFieldEmpty(ssn) && isFieldEmpty(employerId))
                || (!isFieldEmpty(ssn) && !isFieldEmpty(employerId))) {

                isFormValid = false;
                validationErrs = {
                    name: constants.FORM_DATA.TAX_ID,
                    value: errorMessages.tax_id_required
                }
                props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
            }
        }

        //password is required        
        const password = props.formData.get(constants.FORM_DATA.PASSWORD);

        if (!validatePasswordPolicy(password)) {
            isFormValid = false;
            validationErrs = {
                name: constants.FORM_DATA.PASSWORD,
                value: errorMessages.password_field_required
            }
            props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
        }
        //confirm password is required
        const confirmPassword = props.formData.get(constants.FORM_DATA.CONFIRM_PASSWORD);

        if (isFieldEmpty(confirmPassword)) {
            isFormValid = false;
            validationErrs = {
                name: constants.FORM_DATA.CONFIRM_PASSWORD,
                value: errorMessages.confirm_password_required
            }
            props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
        }
        //passwords should match 
        if (password != confirmPassword) {
            isFormValid = false;
            validationErrs = {
                name: constants.FORM_DATA.CONFIRM_PASSWORD,
                value: errorMessages.password_should_match
            }
            props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
        }
        return isFormValid;
    }


    const validateFormForBankInfo = () => {
        const errorMessages = defineMessages({
            routing_number_required: {
                id: 'routing_number_required',
                description: 'Please enter Routing number',
                defaultMessage: 'Please enter Routing number'
            },
            institute_id_required:{
                id:'institute_id_required',
                description:'Please enter 3 digit Institue Id',
                defaultMessage:'Please enter 3 digit Institute Id'
            },
            transit_id_required:{
                id:'transit_id_required',
                description:'Please enter 5 digit Transit Id',
                defaultMessage:'Please enter 5 digit Transit Id'
            },
            check_number_required: {
                id: 'check_number_required',
                description: 'Please enter the Checking account number',
                defaultMessage: 'Please enter the Checking account number'
            },
            check_number_required_canada: {
                id: 'check_number_required_canada',
                description: 'Please enter Financial Institution account number',
                defaultMessage: 'Please enter Financial Institution account number'
            },
            re_enter_check_number_rquired: {
                id: 're_enter_check_number_rquired',
                description: 'Please re enter the Checking account number',
                defaultMessage: 'Please re enter the Checking account number'
            },
            re_enter_check_number_rquired_canada: {
                id: 're_enter_check_number_rquired_canada',
                description: 'Please re enter Financial Institution account number',
                defaultMessage: 'Please re enter Financial Institution account number'
            },
            check_numbers_should_match: {
                id: 'check_numbers_should_match',
                description: 'Both account numbers must be identical. Please re-enter checking account number',
                defaultMessage: 'Both account numbers must be identical. Please re-enter checking account number'
            },
            payment_email_required: {
                id: 'payment_email_required',
                description: 'Please enter the Payment email address',
                defaultMessage: 'Please enter the Payment email address'
            },
            invalid_email_format: {
                id: 'invalid_email_format',
                description: 'Payment email format is invalid',
                defaultMessage: 'Payment email format is invalid'
            },
            invalid_routing_number: {
                id: 'invalid_routing_number',
                description: 'The first digit should start with 0,1,2 or 3',
                defaultMessage: 'The first digit should start with 0,1,2 or 3'
            },
            routing_number_should_be_9_digits: {
                id: 'invalid_routing_number',
                description: 'Routing number has to be 9 digits',
                defaultMessage: 'Routing number has to be 9 digits'
            },
            
        })
        
        let isFormValid = true;
        let validationErrs;
        const country=props.formData.get(constants.FORM_DATA.COUNTRY);
        if(country=='CAN'){
            const instituteId=props.formData.get(constants.FORM_DATA.INSTITUTE_ID);
            if(isFieldEmpty(instituteId) || instituteId.length<3){
                isFormValid=false;
                validationErrs = {
                    name: constants.FORM_DATA.INSTITUTE_ID,
                    value: errorMessages.institute_id_required
                }
                props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
            }

            const transitId=props.formData.get(constants.FORM_DATA.TRANSIT_ID);
            if(isFieldEmpty(transitId) || transitId.length<5){
                isFormValid=false;
                validationErrs = {
                    name: constants.FORM_DATA.TRANSIT_ID,
                    value: errorMessages.transit_id_required
                }
                props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
        
            }
        }
        else if(country=='USA'){
            //required fields
            const routingNumber = props.formData.get(constants.FORM_DATA.ROUTING_NUMBER);
        
            if (isFieldEmpty(routingNumber)) {
                isFormValid = false;
                validationErrs = {
                    name: constants.FORM_DATA.ROUTING_NUMBER,
                    value: errorMessages.routing_number_required
                }
                props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
            }
            else {
                const firstChar = routingNumber.toString().substr(0, 1);
                const routingCharsAllowed = ['0', '1', '2', '3'];

                if (!routingCharsAllowed.includes(firstChar)) {
                    isFormValid = false;
                    validationErrs = {
                        name: constants.FORM_DATA.ROUTING_NUMBER,
                        value: errorMessages.invalid_routing_number
                    }
                    props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
                }

                else if (routingNumber.length != 9) {
                    isFormValid = false;
                    validationErrs = {
                        name: constants.FORM_DATA.ROUTING_NUMBER,
                        value: errorMessages.routing_number_should_be_9_digits
                    }
                    props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
                }
            }
        }
        if(country!='MEX'){
            const checkingNumber = props.formData.get(constants.FORM_DATA.CHECKING_ACC_NUMBER);
            if (isFieldEmpty(checkingNumber)) {
                isFormValid = false;
                validationErrs = {
                    name: constants.FORM_DATA.CHECKING_ACC_NUMBER,
                    value: country=='CAN'? errorMessages.check_number_required_canada:errorMessages.check_number_required
                }
                props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
            }

            const reEnterCheckingNumber = props.formData.get(constants.FORM_DATA.CONFIRM_CHECKING_ACC_NUMBER);
            if (isFieldEmpty(reEnterCheckingNumber)) {
                isFormValid = false;
                validationErrs = {
                    name: constants.FORM_DATA.CONFIRM_CHECKING_ACC_NUMBER,
                    value: country=='CAN'? errorMessages.re_enter_check_number_rquired_canada:errorMessages.re_enter_check_number_rquired
                }
                props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
            }

       

            //checking numbers should match 
            if (checkingNumber != reEnterCheckingNumber) {
                isFormValid = false;
                validationErrs = {
                    name: constants.FORM_DATA.CONFIRM_CHECKING_ACC_NUMBER,
                    value:errorMessages.check_numbers_should_match
                }
                props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
            }
        }

        const paymentEmail = props.formData.get(constants.FORM_DATA.PAYMENT_EMAIL);
        if (isFieldEmpty(paymentEmail)) {
            isFormValid = false;
            validationErrs = {
                name: constants.FORM_DATA.PAYMENT_EMAIL,
                value: errorMessages.payment_email_required
            }
            props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
        }

        //payment email address 
        if (!validateEmail(paymentEmail)) {
            isFormValid = false;
            validationErrs = {
                name: constants.FORM_DATA.PAYMENT_EMAIL,
                value: errorMessages.invalid_email_format
            }
            props.dispatch({ type: constants.UPDATE_FORM_DATA_VALIDATION_ERRS, validationErrs })
        }

        return isFormValid;
    }

    const validateFormAuthEmailConfig = () => {
        const errorMessages = defineMessages({
            atleast_one_email_required: {
                id: 'atleast_one_email_required',
                description: 'Please enter atleast one email',
                defaultMessage: 'Please enter atleast one email'
            },
            name_email_required: {
                id: 'name_email_required',
                description: 'Both Name and Email are required',
                defaultMessage: 'Both Name and Email are required'
            },
            invalid_email_format: {
                id: 'invalid_email_format',
                description: 'Email format is invalid',
                defaultMessage: 'Email format is invalid'
            },
            invalid_is_registered: {
                id: 'invalid_is_registered',
                description: 'Either register for notification emails or opt out',
                defaultMessage: 'Either register for notification emails or opt out'
            },
        })

        let isFormValid = true;
        let validationErrs;
        let contacts = props.authorizationEmailConfig.get('contacts');

        if (props.authorizationEmailConfig.get('isRegistered') == undefined) {
            isFormValid = false;            
            validationErrs = {
                name: 'isRegistered',
                value: errorMessages.invalid_is_registered
            }
            props.dispatch({ type: constants.UPDATE_EMAIL_CONFIG_VALIDATION_ERRS, validationErrs })
        }

        if (contacts != undefined && contacts.length > 0) {

            for (var index = 0; index < contacts.length; index++) {

                //required 
                if ((isFieldEmpty(contacts[index].name) && !isFieldEmpty(contacts[index].email))
                    || (!isFieldEmpty(contacts[index].name) && isFieldEmpty(contacts[index].email))
                    || (isFieldEmpty(contacts[index].name) && isFieldEmpty(contacts[index].email))
                    ) {
                    isFormValid = false;
                    validationErrs = {
                        name: index,
                        value: errorMessages.name_email_required
                    }
                    props.dispatch({ type: constants.UPDATE_EMAIL_CONFIG_VALIDATION_ERRS, validationErrs })
                }

                //email format
                if (!isFieldEmpty(contacts[index].email) && !validateEmail(contacts[index].email)) {
                    isFormValid = false;
                    validationErrs = {
                        name: index,
                        value: errorMessages.invalid_email_format
                    }
                    props.dispatch({ type: constants.UPDATE_EMAIL_CONFIG_VALIDATION_ERRS, validationErrs })
                }
            }
        }

        return isFormValid;
    }

    const validateTermsAndConditions = () => {

        const errorMessages = defineMessages({
            terms_and_conditions_required: {
                id: 'terms_and_conditions_required',
                description: 'terms_and_conditions_required',
                defaultMessage: 'Please accepted Terms And Conditions'
            },

        });

        let isFormValid = true;
        let validationErrs;


        if (!props.toggleAcceptedFlag) {
            isFormValid = false;
            validationErrs = {
                name: "TERMS_AND_CONDITIONS",
                value: errorMessages.terms_and_conditions_required
            }
            props.dispatch({ type: "TERMS_AND_CONDITIONS_VALIDATION_ERRS", validationErrs })
        }else{
            isFormValid = true;
            removeValidationErr("TERMS_AND_CONDITIONS")

        }



        return isFormValid;
    }

    const onAcceptedTermsHandler = () => {

        props.dispatch({type:  constants.TOGGLE_TERMS_AND_CONDITIONS_ACCEPTED })
    }

    const onSubmitHandler = (step) => {

        switch (step) {
            case 1:
                if (validateFormForAccountInfo()) {
                    props.dispatch({ type: constants.SUBMIT_ACCOUNT_INFO });
                }
                break;
            case 2:
                if ((props.tcInitialsAcceptedFlag != undefined && props.tcInitialsAcceptedFlag.length == 2) && props.toggleAcceptedFlag) {
                    props.dispatch({type: constants.SAVE_TERMS_AND_CONDITIONS_STATUS,termsAndConditionsFlag: true});
                    props.dispatch({type:"ACCEPTED_TERMS_AND_CONDITIONS_SUBMISSION_REGISTER"});
                }else{
                    props.dispatch(appActions.tcConditionTermsAndConditionsChecked(true))
                }
                break;
            case 3:
                if (validateFormForBankInfo()) {
                    props.dispatch({ type: constants.SUBMIT_BANK_INFO })
                }
                break;
            case 4:
                props.dispatch({ type: constants.SAVE_VENDOR_SERVICES_FOR_REGISTRATION });
                break;
            case 5:
                if(props.isVendorPreferredContactEnabled || validateFormAuthEmailConfig()) {
                    props.dispatch({ type: constants.SAVE_EMAIL_AUTH_NOTIFICATION, isVendorPreferredContactEnabled: props.isVendorPreferredContactEnabled });
                }
                break;
            default:
                break;
        }
    }

    const onChangeRegistrationFieldValueHandler = (inputName, event) => {
        let registrationField = {
            name: inputName,
            value: event.target.value
        };
        props.dispatch({ type: constants.UPDATE_REGISTRATION_FIELD, registrationField: registrationField });
    }

    const onCountryChangeHandler = (country,ariId) => {
        let registrationField = {
            name: constants.FORM_DATA.COUNTRY,
            value: country
        };
        props.dispatch({type:'REGISTRATION_SELECTED_COUNTRY_CHANGED'});
        props.dispatch({ type: constants.UPDATE_REGISTRATION_FIELD, registrationField: registrationField });

        let ariIdField={
            name:constants.FORM_DATA.ARI_ID,
            value:ariId
        }
        props.dispatch({ type: constants.UPDATE_REGISTRATION_FIELD, registrationField: ariIdField });
        
        if(country=="MEX"){            
            props.dispatch(sharedActions.selectLocale("es-MX"));
            CookieHelper.createCookie('vms_language_preference', JSON.stringify({
                languageLocaleCookie:"es-MX",
            }));
        }
        else
        {
            props.dispatch(sharedActions.selectLocale("en-US"));
            CookieHelper.createCookie('vms_language_preference', JSON.stringify({
                languageLocaleCookie:"en-US",
            }));
        }
        props.dispatch(sharedActions.setSelectedCountry(country));
    }

    const nextStepHandler = () => {
        props.dispatch({ type: constants.REGISTRATION_NEXT_STEP });
    }

    const removeValidationErr = (fieldName) => {
        props.dispatch({ type: constants.REMOVE_VALIDATION_ERROR, fieldName })
    }
    const removeContactHandler = (index, event) => {
        let updatedContacts = props.authorizationEmailConfig.get('contacts');
        updatedContacts.splice(index, 1);
        props.dispatch({ type: constants.REMOVE_NOTIFICATION_CONTACT, updatedContacts })
    }
    const addContactRowHandler = () => {
        let contacts = props.authorizationEmailConfig.get('contacts');
        let updatedContacts = contacts.concat({ seq: contacts.length + 1, name: '', email: '' });
        props.dispatch({ type: constants.UPDATE_NOTIFICATION_CONTACT, updatedContacts })
    }

    const updateContactHandler = (inputName, index, event) => {
        if (event != undefined) {
            let updatedContacts = props.authorizationEmailConfig.get('contacts');
            updatedContacts[index][inputName] = event.target.value;
            props.dispatch({ type: constants.UPDATE_NOTIFICATION_CONTACT, updatedContacts })
        }
    }
    const updateEmailConfigRegistrationHandler = (isRegistered) => {
        props.dispatch({ type: constants.UPDATE_EMAIL_CONFIG_REGISTRATION, isRegistered })
    }
    const removeValidationErrForAuthEmailConfigHandler = (fieldName) => {
        props.dispatch({ type: constants.REMOVE_EMAIL_CONFIG_VALIDATION_ERRS, fieldName })
    }
    const loadVendorServicesHandler = () => {
        props.dispatch({ type: constants.FETCH_VENDOR_SERVICES_FOR_REGISTRATION });
    }

    //Vendor service profile events
    const ChangeVendorServicesClickHandler = () => {

    }
    const vendorServicesSelectedHandler = (selectedValue, serviceId) => {
        // onBlurChange();
        if (selectedValue) {
            props.dispatch({ type: constants.VENDOR_SERVICE_SELECTED_FOR_REGISTRATION, servicesSelected: false, serviceKey: serviceId });
        } else {
            props.dispatch({ type: constants.VENDOR_SERVICE_SELECTED_FOR_REGISTRATION, servicesSelected: true, serviceKey: serviceId });
        }
    }
    const ServicesCancelClickEvent = () => {

    }
    const vendorMinoritySelectedHandler = (serviceId) => {
        props.vendorMinority.map(service => {
            props.dispatch({ type: constants.VENDOR_MINORITY_SELECTED_FOR_REGISTRATION, minoritySelected: false, minorityKey: service.get("id") });
        });
        props.dispatch({ type: constants.VENDOR_MINORITY_SELECTED_FOR_REGISTRATION, minoritySelected: true, minorityKey: serviceId });
    }
    const onSaveVendorServicesClickHandler = () => {
        props.dispatch({ type: constants.SAVE_VENDOR_SERVICES_FOR_REGISTRATION });
    }
    const onBlurChange = () => {
    }

    const onToggleAcceptedTermsHandler = () => {
    
        props.dispatch(appActions.termsAndConditionsToggleAccepted());
    }

    const onInitialsAcceptedTermsHandler = (tcInitialsValue) => {
        props.dispatch(appActions.termsAndConditionsInitialsAccepted(tcInitialsValue));
 
    }


    const renderView = () => {

        return (
            <div className='registration'>
                {
                    step == 'accountInfo' ?
                        <AccountInfo onSubmitStep={onSubmitHandler}
                            onChangeRegistrationFieldValue={onChangeRegistrationFieldValueHandler}
                            formDataValidationMessages={props.formDataValidationMessages}
                            removeValidationErr={removeValidationErr}
                            isSubmittingAccountInfo={props.isSubmittingAccountInfo}
                            country={props.formData.get(constants.FORM_DATA.COUNTRY)}
                            error={renderError('accountInfoErrorMessage', props, props.accountInfoErrorMessage)}
                            onCountryChange={onCountryChangeHandler}
                            formData={props.formData}
                        />
                        : undefined
                }
                {
                    step === 'vendorTermsAndConditions' ?
                           <div>
                                 <TermsAndConditions
                                       termsAndConditions={props.termsAndConditions}
                                       toggleAcceptedFlag={props.toggleAcceptedFlag}
                                       onAcceptedTerms={onAcceptedTermsHandler}
                                       isFetchingTermsAndConditions={props.isFetchingTermsAndConditions}
                                       onSubmitStep={onSubmitHandler}
                                       isFetchingTermsAndConditionsAccepted={props.isFetchingTermsAndConditionsAccepted}
                                       error={renderError('termsAndConditionsErrorMessage', props, props.termsAndConditionsErr)}
                                       formDataValidationMessages={props.formDataValidationMessages}
                                       termsAndConditionsErr={props.termsAndConditionsErr}
                                       tcContinueValdiationFlag = {props.tcContinueValdiationFlag}
                                       tcInitialsAcceptedFlag={props.tcInitialsAcceptedFlag}
                                       onToggleAcceptedTerms={onToggleAcceptedTermsHandler}
                                       onInitialsAcceptedTerms={onInitialsAcceptedTermsHandler}

                        />
                    </div>
                    : undefined
                }
                {
                    step == 'bankingInfo' ?
                        <BankingInfo
                            formData={props.formData}
                            onSubmitStep={onSubmitHandler}
                            onChangeRegistrationFieldValue={onChangeRegistrationFieldValueHandler}
                            isSubmittingBankInfo={props.isSubmittingBankInfo}
                            formDataValidationMessages={props.formDataValidationMessages}
                            removeValidationErr={removeValidationErr}
                            country={props.formData.get(constants.FORM_DATA.COUNTRY)}
                            error={renderError('bankInfoErrorMessage', props, props.bankInfoErrorMessage)}
                        />
                        : undefined
                }
                {
                    step == 'serviceProfile' ?
                        <ServiceProfile
                            onSubmitStep={onSubmitHandler}
                            vendorServices={props.vendorServices}
                            vendorMinority={props.vendorMinority}
                            minoritySelected={props.minoritySelected}
                            loadVendorServices={loadVendorServicesHandler}
                            vendorServicesSelected={vendorServicesSelectedHandler}
                            vendorMinoritySelected={vendorMinoritySelectedHandler}
                            onSaveVendorServices={onSaveVendorServicesClickHandler}
                            isFetchingServiceInfo={props.isFetchingServiceInfo}
                            isSubmittingServiceInfo={props.isSubmittingServiceInfo}
                            error={renderError('serviceInfoErrorMessage', props, props.serviceInfoErrorMessage)}
                            showVendorMinority={true}
                            country={props.formData.get(constants.FORM_DATA.COUNTRY)}
                        />
                        : undefined
                }
                {
                    step == 'authEmailNotification' ?
                        props.isVendorPreferredContactEnabled ?
                            <ServiceContact 
                                vendorClient={props.vendorClient} 
                                vendorId={props.vendorId} 
                                isRegistration={true} 
                                submitRegistration={() => { onSubmitHandler(5) }} 
                                userLocale={props.selectedLocale}/>
                            : <AuthEmailNotification
                                formMode={constants.ADD}
                                onSubmitStep={onSubmitHandler}
                                onChangeRegistrationFieldValue={onChangeRegistrationFieldValueHandler}
                                addContactRow={addContactRowHandler}
                                updateContact={updateContactHandler}
                                removeContact={removeContactHandler}
                                authorizationEmailConfig={props.authorizationEmailConfig.get('contacts')}
                                isRegistered={props.authorizationEmailConfig.get('isRegistered')}
                                updateEmailConfigRegistration={updateEmailConfigRegistrationHandler}
                                authorizationEmailConfigValidationErrs={props.authorizationEmailConfigValidationErrs}
                                removeValidationErrForAuthEmailConfig={removeValidationErrForAuthEmailConfigHandler}
                                isSubmittingAuthEmailConfigInfo={props.isSubmittingAuthEmailConfigInfo}
                                error={renderError('authorizationEmailConfigErrormessage', props, props.authorizationEmailConfigErrormessage)}
                                tabIndexStartFrom={100}
                            />
                        : undefined
                }
            </div>
        );

    };

    return renderView();
};

function mapPropsToState(state, props) {
    return {
        ...RegistrationViewSelector(state, props),
        currentStep: state.appState.getIn(['uiData', 'registrationView', 'currentStep']),
        formDataValidationMessages: state.appState.getIn(['uiData', 'registrationView', 'formDataValidationErrs']),
        authorizationEmailConfig: state.appState.getIn(['uiData', 'registrationView', 'authorizationEmailConfig']),
        authorizationEmailConfigValidationErrs: state.appState.getIn(['uiData', 'registrationView', 'authorizationEmailConfigValidationErrs', 'contacts']),
        isSubmittingAccountInfo: state.appState.getIn(['uiData', 'registrationView', 'isSubmittingAccountInfo']),
        isSubmittingBankInfo: state.appState.getIn(['uiData', 'registrationView', 'isSubmittingBankInfo']),
        isFetchingServiceInfo: state.appState.getIn(['uiData', 'registrationView', 'isFetchingServiceInfo']),
        isSubmittingServiceInfo: state.appState.getIn(['uiData', 'registrationView', 'isSubmittingServiceInfo']),
        isSubmittingAuthEmailConfigInfo: state.appState.getIn(['uiData', 'registrationView', 'isSubmittingAuthEmailConfigInfo']),
        termsAndConditions:state.appState.getIn(['serverData', 'shared', 'vendorTermsAndConditions']) || null,
        acceptedTermsAndConditions:state.appState.getIn(['serverData', 'shared', 'acceptedTermsAndConditions']),
        toggleAcceptedFlag:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','toggleAcceptedFlag']) || false,
        isFetchingTermsAndConditions:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','isFetchingTermsAndCondition']) || false,
        tcInitialsAcceptedFlag:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','tcInitialsAcceptedFlag']) || undefined,
        tcContinueValdiationFlag:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','tcContinueValdiationFlag']) || false,
        isFetchingTermsAndConditionsAccepted:state.appState.getIn(['uiData', 'shared', 'vendorTermsAndConditions','isFetchingTermsAndConditionAccepted']) || false,
        termsAndConditionsErr:state.appState.getIn(['uiData', 'registrationView','formDataValidationErrs','TERMS_AND_CONDITIONS']),
        vendorId: state.appState.getIn(['serverData', 'shared', 'vendorId']),
        selectedLocale: emptyStringIfUndefined(state.appState.getIn(['uiData', 'shared', 'selectedLocale']))  
    }
}

export default connect(mapPropsToState)(RegistrationView);
